import HttpClientToken from '../../services/HttpClientToken';

import { TipoSentenciaProps, defaultTipoSentencia } from '../../interfaces/catalogos/TipoSentenciaInterface';

export const TipoSentencias = () => {

    return new Promise<TipoSentenciaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoSentencia/', token)
            .then( ({ data } : { data : TipoSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoSentencia = () => {

    return new Promise<TipoSentenciaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoSentencia/ObtenerTipoSentencias', token)
            .then( ({ data } : { data : TipoSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoSentencia = ( params: TipoSentenciaProps ) => {

    return new Promise<TipoSentenciaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoSentencia/Actualizar', params, token)
            .then( ({ data } : { data : TipoSentenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoSentencia } );
            });

        }

    });

}

export const AgregarTipoSentencia = ( params: TipoSentenciaProps ) => {

    return new Promise<TipoSentenciaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoSentencia/Agregar', params, token)
            .then( ({ data } : { data : TipoSentenciaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoSentencia } );
            });

        }

    });

}
